import React from 'react';
import Background from './components/Background';
import CardContainer from './components/CardContainer';
import Sidebar from './components/Sidebar';
import { LanguageProvider } from './container/Language';
import * as styles from './App.css'

function App() {
  return (
    <div className="page new-skin">
      <LanguageProvider>
        <Background />
        <Sidebar />
        <CardContainer />
      </LanguageProvider>
    </div>
  );
}

export default App;
